export const TASK_LIST_COLUMN_DEFINITIONS = [
	{ key: "name", titleKey: "Task Name" },
	{ key: "startTime", titleKey: "Start Time" },
	{ key: "expectedDuration", titleKey: "Duration" },
	{ key: "priority", titleKey: "Priority" },
	{ key: "poi", titleKey: "POI Name" },
	{ key: "status", titleKey: "status" },
	{ key: "assignedTo", titleKey: "Assigned To" },
	{ key: "type", titleKey: "Type" },
	{ key: "startDate", titleKey: "Start Date" },
	{ key: "createdBy", titleKey: "Created By" },
	{ key: "updatedAt", titleKey: "last update" },
];

export const ALL_TASK_LIST_COLUMN_KEYS = TASK_LIST_COLUMN_DEFINITIONS.map(
	(c) => c.key
);

export const TASK_LIST_COLUMNS_STORAGE_KEY = "tasksListVisibleColumns";

export function loadVisibleTaskListColumnKeys() {
	try {
		const stored = JSON.parse(
			localStorage.getItem(TASK_LIST_COLUMNS_STORAGE_KEY)
		);
		if (Array.isArray(stored)) {
			const filtered = stored.filter((k) =>
				ALL_TASK_LIST_COLUMN_KEYS.includes(k)
			);
			if (filtered.length) return filtered;
		}
	} catch {
		// ignore malformed storage value
	}
	return ALL_TASK_LIST_COLUMN_KEYS;
}
